import './CampusRec.css';
import '@fontsource/inter';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';
import React, { useState } from 'react';

function CampusRec() {
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks which dropdown is open

    // Toggle function for dropdowns
    const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };

    return (
        <section className="campus-rec-container">
            <CurrentTime />
            <DynamicIsland />
            <Back />

            <div className="campus-recreation">
                <h1>Campus Recreation</h1>
                <h2>
                    Get more involved on campus while doing something fun. Campus Recreation
                    provides state-of-the-art facilities and programs that promote active and
                    healthy lifestyles.
                </h2>
                <div className="campus-iframe-wrapper">
                    <h3>
                        Check out the brand new virtual tour produced by Towson Campus Recreation!
                    </h3>
                    <iframe
                        src="https://www.youtube.com/embed/hE2PMesd6pQ?"
                        title="Campus Recreation"
                        className="campus-rec-tour"
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                </div>
                <h3>
                    Campus Recreation supports the Towson University community by providing
                    facilities and programs that promote physical and social benefits. Whether you
                    want to get active, challenge yourself with an outdoor adventure, or just have
                    some fun with your friends, Campus Recreation has something to offer you.
                </h3>


            <div className="campus-dropdown">
                <button
                    onClick={() => toggleDropdown('protocols')}
                    className="campus-dropdown-button"
                >
                    Guidelines and Protocols
                </button>
                <div
                    className={`campus-dropdown-content ${
                        openDropdown === 'protocols' ? 'dropdown-open' : 'dropdown-closed'
                    }`}
                >
                    <ol>
                        <li>Use the TU Campus Rec mobile app for touchless entry into the facility.</li>
                        <li>Bring your own water bottles. Water bottle filling stations are available.</li>
                        <li>Locker rooms are available for showers, towel service, and locker rental.</li>
                        <li>Day use lockers are available. Bring your own lock or check one out at the Equipment Room.</li>
                    </ol>
                </div>

                <h2>Frequently Asked Questions</h2>
                <button
                    onClick={() => toggleDropdown('facility-open')}
                    className="campus-dropdown-button"
                >
                    When is the facility open?
                </button>
                <div
                    className={`campus-dropdown-content ${
                        openDropdown === 'facility-open' ? 'dropdown-open' : 'dropdown-closed'
                    }`}
                >
                    <ol>
                        <li>Facility hours are available on the TU Campus Rec website and mobile app.</li>
                        <li>Additional resources can be found at the welcome desk.</li>
                    </ol>
                </div>
                
                <button
                    onClick={() => toggleDropdown('program-open')}
                    className="campus-dropdown-button"
                > How do I register for a program?
                </button>
                <div
                    className={`campus-dropdown-content ${
                        openDropdown === 'program-open' ? 'dropdown-open' : 'dropdown-closed'
                    }`}
                ><p>Follow the steps for <a href="https://www.towson.edu/studentlife/activities/recreation/campusrec/how_to_register_for_a_program.pdf">How to Register for a Program</a>.</p>
                </div>
                <button
                    onClick={() => toggleDropdown('program-cancel')}
                    className="campus-dropdown-button"
                > How do I cancel a program?
                </button>
                <div
                    className={`campus-dropdown-content ${
                        openDropdown === 'program-cancel' ? 'dropdown-open' : 'dropdown-closed'
                    }`}
                ><p>Follow the steps for <a href="https://www.towson.edu/studentlife/activities/recreation/campusrec/documents/how_to_cancel__program_registrations.pdf">How to Cencel - Program Registrations</a>.</p>
                </div>
                </div>
                {/* <div className="web-campus-container">
                <div className="web-iframe-wrapper">
                    <iframe
                        src="https://recreation.towson.edu/program/GetProgramDetails?courseId=3d8264af-c60e-44b2-994a-c3606476dfbe"
                        title="Campus Recreation"
                        className="campus-rec-web"
                    ></iframe>
                </div>
            </div> */}
            </div>
        </section>
    );
}

export default CampusRec;
